export default "__VITE_ASSET__CbuCUkHX__"